import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "holiday-manage-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-head-side" }
const _hoisted_4 = {
  key: 0,
  class: "hm-banner hm-banner--warn"
}
const _hoisted_5 = { class: "hm-banner-text" }
const _hoisted_6 = { class: "hm-body" }
const _hoisted_7 = { class: "hm-side" }
const _hoisted_8 = { class: "hm-status" }
const _hoisted_9 = { class: "hm-status-year" }
const _hoisted_10 = { class: "hm-status-grid" }
const _hoisted_11 = { class: "hm-stat ok" }
const _hoisted_12 = { class: "hm-stat-n" }
const _hoisted_13 = { class: "hm-stat-n" }
const _hoisted_14 = { class: "hm-stat muted" }
const _hoisted_15 = { class: "hm-stat-n" }
const _hoisted_16 = { class: "hm-stat custom" }
const _hoisted_17 = { class: "hm-stat-n" }
const _hoisted_18 = { class: "hm-panel" }
const _hoisted_19 = { class: "hm-panel-head" }
const _hoisted_20 = { class: "hm-panel-count" }
const _hoisted_21 = { class: "hm-fixed-list" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "hm-fixed-body" }
const _hoisted_24 = { class: "hm-fixed-top" }
const _hoisted_25 = { class: "hm-fixed-md" }
const _hoisted_26 = { class: "hm-fixed-name" }
const _hoisted_27 = { class: "hm-fixed-sub" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "hm-panel hm-panel--grow" }
const _hoisted_30 = { class: "hm-panel-head" }
const _hoisted_31 = { class: "hm-panel-count" }
const _hoisted_32 = {
  key: 0,
  class: "hm-empty"
}
const _hoisted_33 = {
  key: 1,
  class: "hm-custom-list"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "hm-custom-date" }
const _hoisted_36 = { class: "hm-custom-name" }
const _hoisted_37 = { class: "hm-main" }
const _hoisted_38 = { class: "hm-cal-toolbar" }
const _hoisted_39 = { class: "hm-ym-selects" }
const _hoisted_40 = { class: "hm-weekdays" }
const _hoisted_41 = { class: "hm-grid" }
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = { class: "hm-cell-num" }
const _hoisted_44 = {
  key: 0,
  class: "hm-cell-name"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "hm-dialog-callout"
}
const _hoisted_47 = {
  key: 1,
  class: "hm-dialog-callout hm-dialog-callout--muted"
}

import { computed, onMounted, ref, watch } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { holidayManageApi } from '@/services/api';

interface HolidayItem {
  idx: number;
  date: string;
  name: string;
  source: 'fixed' | 'custom';
}

interface FixedItem {
  idx: number;
  month: number;
  day: number;
  name: string;
  mmdd: string;
  fromYear: number | null;
}

type FixedRowState = 'seeded' | 'missing' | 'pending';


export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayManagePage',
  setup(__props) {

const weekLabels = ['일', '월', '화', '수', '목', '금', '토'];

const now = new Date();
const viewYear = ref(now.getFullYear());
const viewMonth = ref(now.getMonth() + 1);
const loading = ref(false);
const saving = ref(false);
const yearHolidays = ref<HolidayItem[]>([]);
const fixedList = ref<FixedItem[]>([]);

const dialogOpen = ref(false);
const dialogDate = ref('');
const formName = ref('');
const editing = ref<HolidayItem | null>(null);

const yearSelectItems = computed(() => {
  const cur = new Date().getFullYear();
  const years: number[] = [];
  for (let y = cur + 5; y >= cur - 12; y -= 1) years.push(y);
  if (!years.includes(viewYear.value)) {
    years.push(viewYear.value);
    years.sort((a, b) => b - a);
  }
  return years.map((y) => ({ value: y, title: `${y}년` }));
});

const monthSelectItems = computed(() =>
  Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    title: `${i + 1}월`,
  }))
);

const pad2 = (n: number) => String(n).padStart(2, '0');

const holidayMap = computed(() => {
  const map: Record<string, HolidayItem> = {};
  for (const h of yearHolidays.value) {
    map[h.date] = h;
  }
  return map;
});

const customYearHolidays = computed(() =>
  yearHolidays.value.filter((h) => h.source !== 'fixed')
);

const customYearHolidaysSorted = computed(() =>
  [...customYearHolidays.value].sort((a, b) => a.date.localeCompare(b.date))
);

const fixedDateKey = (f: FixedItem, year: number) =>
  `${year}-${pad2(f.month)}-${pad2(f.day)}`;

const isFixedActiveForViewYear = (f: FixedItem) =>
  !(f.fromYear != null && viewYear.value < f.fromYear);

const isFixedSeededOnCalendar = (f: FixedItem) => {
  if (!isFixedActiveForViewYear(f)) return false;
  const hit = holidayMap.value[fixedDateKey(f, viewYear.value)];
  return !!hit && hit.source === 'fixed';
};

const fixedRowState = (f: FixedItem): FixedRowState => {
  if (!isFixedActiveForViewYear(f)) return 'pending';
  return isFixedSeededOnCalendar(f) ? 'seeded' : 'missing';
};

const seededFixedCount = computed(
  () => fixedList.value.filter((f) => fixedRowState(f) === 'seeded').length
);
const missingFixedCount = computed(
  () => fixedList.value.filter((f) => fixedRowState(f) === 'missing').length
);
const pendingFixedCount = computed(
  () => fixedList.value.filter((f) => fixedRowState(f) === 'pending').length
);

const todayKey = computed(() => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
});

const calendarCells = computed(() => {
  const y = viewYear.value;
  const m = viewMonth.value;
  const first = new Date(y, m - 1, 1);
  const startDow = first.getDay();
  const daysInMonth = new Date(y, m, 0).getDate();
  const prevDays = new Date(y, m - 1, 0).getDate();

  const cells: Array<{
    key: string;
    date: string;
    day: number;
    dow: number;
    inMonth: boolean;
    isToday: boolean;
    holiday?: HolidayItem;
  }> = [];

  for (let i = 0; i < 42; i++) {
    let day: number;
    let inMonth = true;
    let cellY = y;
    let cellM = m;

    if (i < startDow) {
      day = prevDays - startDow + i + 1;
      inMonth = false;
      cellM = m === 1 ? 12 : m - 1;
      cellY = m === 1 ? y - 1 : y;
    } else if (i >= startDow + daysInMonth) {
      day = i - startDow - daysInMonth + 1;
      inMonth = false;
      cellM = m === 12 ? 1 : m + 1;
      cellY = m === 12 ? y + 1 : y;
    } else {
      day = i - startDow + 1;
    }

    const date = `${cellY}-${pad2(cellM)}-${pad2(day)}`;
    cells.push({
      key: `${date}-${i}`,
      date,
      day,
      dow: i % 7,
      inMonth,
      isToday: date === todayKey.value,
      holiday: inMonth ? holidayMap.value[date] : undefined,
    });
  }
  return cells;
});

const dialogDateLabel = computed(() => {
  if (!dialogDate.value) return '공휴일';
  const [y, mo, d] = dialogDate.value.split('-').map(Number);
  const dow = new Date(y, mo - 1, d).getDay();
  return `${y}년 ${mo}월 ${d}일 (${weekLabels[dow]})`;
});

const formatShortDate = (date: string) => {
  const m = Number(date.slice(5, 7));
  const d = Number(date.slice(8, 10));
  return `${m}/${d}`;
};

const mapHolidayItems = (items: any[]): HolidayItem[] =>
  (items || []).map((h: any) => ({
    idx: h.idx,
    date: String(h.date).substring(0, 10),
    name: h.name || '',
    source: h.source === 'fixed' ? 'fixed' : 'custom',
  }));

const loadFixed = async () => {
  try {
    const res = await holidayManageApi.getFixed();
    if (res.data?.success) {
      fixedList.value = (res.data.data?.items || []).map((f: any) => ({
        idx: f.idx,
        month: Number(f.month),
        day: Number(f.day),
        name: String(f.name || ''),
        mmdd: String(f.mmdd || `${pad2(f.month)}-${pad2(f.day)}`),
        fromYear: f.fromYear != null ? Number(f.fromYear) : null,
      }));
    }
  } catch (e: any) {
    console.error(e);
  }
};

const loadYear = async () => {
  loading.value = true;
  try {
    const res = await holidayManageApi.listByYear(viewYear.value);
    if (!res.data?.success) {
      throw new Error(res.data?.message || '공휴일 조회 실패');
    }
    yearHolidays.value = mapHolidayItems(res.data.data?.items || []);
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`공휴일 조회 실패: ${message}`);
    console.error('공휴일 조회 오류:', error);
  } finally {
    loading.value = false;
  }
};

const ensureYear = async () => {
  loading.value = true;
  try {
    const res = await holidayManageApi.ensureYear(viewYear.value);
    if (!res.data?.success) {
      throw new Error(res.data?.message || '반영 실패');
    }
    yearHolidays.value = mapHolidayItems(res.data.data?.items || []);
    const inserted = res.data.data?.seed?.inserted ?? 0;
    alert(
      inserted > 0
        ? `${viewYear.value}년 고정 공휴일 ${inserted}건을 반영했습니다.`
        : `${viewYear.value}년 고정 공휴일은 모두 반영되어 있습니다.`
    );
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`고정 공휴일 반영 실패: ${message}`);
  } finally {
    loading.value = false;
  }
};

const onYearChange = (y: number) => {
  if (Number.isFinite(y)) viewYear.value = y;
};

const onMonthChange = (m: number) => {
  if (Number.isFinite(m) && m >= 1 && m <= 12) viewMonth.value = m;
};

const jumpToFixed = (f: FixedItem) => {
  if (!isFixedActiveForViewYear(f)) return;
  viewMonth.value = f.month;
  const key = fixedDateKey(f, viewYear.value);
  if (holidayMap.value[key]) openDay(key);
};

const goToday = () => {
  const d = new Date();
  viewYear.value = d.getFullYear();
  viewMonth.value = d.getMonth() + 1;
};

const openDay = (date: string) => {
  dialogDate.value = date;
  editing.value = holidayMap.value[date] || null;
  formName.value = editing.value?.name || '';
  dialogOpen.value = true;
};

const closeDialog = () => {
  dialogOpen.value = false;
  formName.value = '';
  editing.value = null;
  dialogDate.value = '';
};

const saveHoliday = async () => {
  const name = formName.value.trim();
  if (!name || !dialogDate.value) return;
  saving.value = true;
  try {
    const res = await holidayManageApi.upsert({ date: dialogDate.value, name });
    if (!res.data?.success) {
      throw new Error(res.data?.message || '저장 실패');
    }
    await loadYear();
    closeDialog();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`공휴일 저장 실패: ${message}`);
  } finally {
    saving.value = false;
  }
};

const deleteHoliday = async () => {
  if (!editing.value) return;
  const isFixed = editing.value.source === 'fixed';
  const msg = isFixed
    ? `「${editing.value.name}」을(를) ${viewYear.value}년에서만 삭제할까요?\n목록에는 남고, 나중에 「빠진 고정 반영」으로 복구할 수 있습니다.`
    : `「${editing.value.name}」을(를) 삭제할까요?`;
  if (!confirm(msg)) return;
  saving.value = true;
  try {
    const res = await holidayManageApi.remove(editing.value.idx);
    if (!res.data?.success) {
      throw new Error(res.data?.message || '삭제 실패');
    }
    await loadYear();
    closeDialog();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`공휴일 삭제 실패: ${message}`);
  } finally {
    saving.value = false;
  }
};

watch(viewYear, () => {
  loadYear();
});

onMounted(async () => {
  await loadFixed();
  await loadYear();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      show: loading.value || saving.value,
      text: saving.value ? '저장 중...' : '불러오는 중...'
    }, null, 8, ["show", "text"]),
    _createElementVNode("header", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "설정"),
        _createElementVNode("h2", { class: "console-title" }, "공휴일관리")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_btn, {
          variant: "flat",
          class: "btn-refresh",
          disabled: loading.value || missingFixedCount.value === 0,
          onClick: ensureYear
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "16",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-sync", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" 빠진 고정 " + _toDisplayString(missingFixedCount.value) + "건 반영 ", 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    (missingFixedCount.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("strong", null, _toDisplayString(viewYear.value) + "년", 1),
            _cache[4] || (_cache[4] = _createTextVNode(" 달력에 고정 공휴일 ", -1)),
            _createElementVNode("strong", null, _toDisplayString(missingFixedCount.value) + "건", 1),
            _cache[5] || (_cache[5] = _createTextVNode("이 빠져 있습니다. ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hm-banner-sub" }, "삭제했거나 아직 반영하지 않은 항목입니다.", -1))
          ]),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-save",
            size: "small",
            disabled: loading.value,
            onClick: ensureYear
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" 지금 반영 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("aside", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(viewYear.value), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(seededFixedCount.value), 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "hm-stat-l" }, "반영됨", -1))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["hm-stat", missingFixedCount.value ? 'warn' : 'muted'])
            }, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(missingFixedCount.value), 1),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "hm-stat-l" }, "빠짐", -1))
            ], 2),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(pendingFixedCount.value), 1),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "hm-stat-l" }, "아직 적용 전", -1))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(customYearHolidays.value.length), 1),
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "hm-stat-l" }, "수동", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "고정 (양력)", -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(fixedList.value.length), 1)
          ]),
          _createElementVNode("ul", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedList.value, (f) => {
              return (_openBlock(), _createElementBlock("li", {
                key: f.idx,
                class: _normalizeClass(["hm-fixed-item", fixedRowState(f)]),
                onClick: ($event: any) => (jumpToFixed(f))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", {
                  class: "hm-fixed-dot",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(f.mmdd), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(f.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (fixedRowState(f) === 'pending')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(f.fromYear) + "년부터 적용 · 지금은 해당 없음 ", 1)
                        ], 64))
                      : (fixedRowState(f) === 'missing')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(viewYear.value) + "년 달력에 없음 · 상단에서 반영 ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (f.fromYear)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(f.fromYear) + "~ · ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(viewYear.value) + "년 반영됨 ", 1)
                          ], 64))
                  ])
                ])
              ], 10, _hoisted_22))
            }), 128))
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "hm-foot-note" }, " 제헌절처럼 시작 연도가 있으면 그 해부터만 달력에 올라갑니다. 고정 항목을 지워도 목록은 남고, 「빠진 고정 반영」으로 복구합니다. ", -1))
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "수동 (설·추석·대체 등)", -1)),
            _createElementVNode("span", _hoisted_31, _toDisplayString(customYearHolidays.value.length), 1)
          ]),
          (!customYearHolidays.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, " 없음 · 달력 날짜를 눌러 추가 "))
            : (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customYearHolidaysSorted.value, (h) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: h.idx,
                    class: "hm-custom-item",
                    onClick: ($event: any) => (openDay(h.date))
                  }, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(formatShortDate(h.date)), 1),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(h.name), 1)
                  ], 8, _hoisted_34))
                }), 128))
              ]))
        ])
      ]),
      _createElementVNode("main", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_v_select, {
              "model-value": viewYear.value,
              items: yearSelectItems.value,
              "item-title": "title",
              "item-value": "value",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "hm-v-select hm-v-select--year",
              "onUpdate:modelValue": onYearChange
            }, null, 8, ["model-value", "items"]),
            _createVNode(_component_v_select, {
              "model-value": viewMonth.value,
              items: monthSelectItems.value,
              "item-title": "title",
              "item-value": "value",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "hm-v-select hm-v-select--month",
              "onUpdate:modelValue": onMonthChange
            }, null, 8, ["model-value", "items"])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "hm-cal-legend" }, [
            _createElementVNode("span", { class: "lg fixed" }, [
              _createElementVNode("i"),
              _createTextVNode("고정")
            ]),
            _createElementVNode("span", { class: "lg custom" }, [
              _createElementVNode("i"),
              _createTextVNode("수동")
            ]),
            _createElementVNode("span", { class: "lg today" }, [
              _createElementVNode("i"),
              _createTextVNode("오늘")
            ])
          ], -1)),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-reset",
            onClick: goToday
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("오늘", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekLabels, (w) => {
            return _createElementVNode("span", {
              key: w,
              class: _normalizeClass({ sun: w === '일', sat: w === '토' })
            }, _toDisplayString(w), 3)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarCells.value, (cell) => {
            return (_openBlock(), _createElementBlock("button", {
              key: cell.key,
              type: "button",
              class: _normalizeClass(["hm-cell", {
              out: !cell.inMonth,
              sun: cell.dow === 0,
              sat: cell.dow === 6,
              today: cell.isToday,
              holiday: !!cell.holiday,
              fixed: cell.holiday?.source === 'fixed',
              custom: cell.holiday?.source === 'custom',
            }]),
              disabled: !cell.inMonth,
              onClick: ($event: any) => (cell.inMonth && openDay(cell.date))
            }, [
              _createElementVNode("span", _hoisted_43, _toDisplayString(cell.day), 1),
              (cell.holiday)
                ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(cell.holiday.name), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_42))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: dialogOpen.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogOpen).value = $event)),
      "max-width": "440",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "hm-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(dialogDateLabel.value), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "hm-dialog__close",
                  disabled: saving.value,
                  "aria-label": "닫기",
                  onClick: closeDialog
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_45)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (editing.value?.source === 'fixed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _cache[19] || (_cache[19] = _createTextVNode(" 고정 공휴일 · ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(viewYear.value) + "년만", 1),
                      _cache[20] || (_cache[20] = _createTextVNode(" 삭제됩니다. 목록(템플릿)은 유지되고, 다시 넣으려면 「빠진 고정 반영」을 누르세요. ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_47, " 설·추석·대체공휴일 등 해마다 다른 날은 여기에 직접 등록합니다. ")),
                _createVNode(_component_v_text_field, {
                  modelValue: formName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formName).value = $event)),
                  label: "공휴일명",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "auto",
                  maxlength: "50",
                  autofocus: "",
                  class: "hm-dialog-field",
                  onKeyup: _withKeys(saveHoliday, ["enter"])
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                (editing.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "flat",
                      class: "btn-delete",
                      disabled: saving.value,
                      onClick: deleteHoliday
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode(" 삭제 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  disabled: saving.value,
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  disabled: saving.value || !formName.value.trim(),
                  onClick: saveHoliday
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" 저장 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})